<template>
    <div> 
        <v-container class="pt-14"> 
            <v-row>
                <v-col cols="12" align="center" justify="center">
                    <p class="headline white--text"> {{ $t('status_header') }}</p>
                </v-col>
            </v-row>

            <v-row
                v-for="stage in status"
                v-bind:key="stage.id"
                align="center"
                justify="center"
            >
                <v-spacer cols="2"></v-spacer>
                <v-col cols="4" class="text-center white--text"> {{ stage[0] }} </v-col>
                <v-col cols="4" class="text-center white--text"> {{ stage[1] }} </v-col>
                <v-spacer cols="2"></v-spacer>
            </v-row>
        </v-container>
        <v-container class="pt-14">
            <v-row>
                <v-col cols="12" @click="$emit('go_back')">
                    <v-card class="rounded-pill pt-2" color="#073955" dark height="40" align="center" hover> <v-icon>mdi-undo</v-icon> {{ $t('status_back_button') }} </v-card>
                </v-col>
                <v-col cols="12" @click="$emit('restart')">
                    <v-card class="rounded-pill pt-2" color="#073955" dark height="40" align="center" hover> <v-icon>mdi-restart</v-icon> {{ $t('restart') }} </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import i18n from '../i18n'
export default {
    name: 'status-screen',
    props: {
        status: Array,
    },
}

</script>
